import Layout from 'src/components/Layout';
// import 'src/styles/components/_dashboard.scss'
import ChannelManager from '../../components/Channels/ChannelManager';
import { useEffect, useState } from 'react';
import { httpClient } from 'src/libs';
import { useSearchParams } from 'react-router-dom';
import { API_ROUTES } from 'src/constants/routes';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import ConfettiExplosion from "react-confetti-explosion";
import { useAppDispatch } from 'src/store';
import { fetchChannels } from 'src/features/account/channels.slice';

const PhonePurchaseSuccess = () => {
  // if the url has /channels then /phone_purchase_success
  const [searchParams, setSearchParams] = useSearchParams();
  const {enqueueSnackbar} = useSnackbar();
  const cs = searchParams.get("checkout_session_id")
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfetti, setShowConfetti] = useState(false);
  const [error, setError] = useState(null); // Add error state
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const quotes = [
  "Remember when? Dial-up took at least 13 minutes to download a 3-minute song. A whole album could take hours!",
  "Dial-up was the first form of internet access. It was slow, but it was a start.",
  "\"Palm Before The Storm (1990s - 2010)\": Palm was iPhone before iPhone.It lost grip, but for a while, those Palm PDAs were peak tech swag!",
  "MySpace's Friendlier Times (2003 - 2008)\": MySpace was our first digital hangout long before Facebook. It might be quiet now, but let's \"Tom\" will forever be our first social media friend.",
  "'Winamp: it really whips the llama's ass!' - was a much-loved, customizable MP3 player developed in 1997."
];
  const [currentQuote, setCurrentQuote] = useState(quotes[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentQuote(quotes[Math.floor(Math.random() * quotes.length)]);
    }, 4000); // Change this to the number of seconds you want.

    return () => clearInterval(intervalId); // This clears the interval on unmount.
  }, []);

  useEffect(() => {
    if (cs) {
      handlePurchasePhoneNumber()
    } else {
      setError('No checkout session ID provided');
      setLoading(false);
    }
  }, [cs]);

  useEffect(() => {
    if (!loading && !error) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 3000);
      enqueueSnackbar('Phone number purchased successfully!', { variant: 'success' });
    }
  }, [loading, error]);

  const handlePurchasePhoneNumber = async () => {
    if (!cs) {
      setError('No checkout session ID provided');
      setLoading(false);
      return;
    }

    try {
      console.log('Processing phone purchase for checkout session:', cs);

      // Call the backend API to process the phone purchase
      const response = await httpClient.post(`${process.env.REACT_APP_API_URL}/twilio_phone_numbers/phone_purchase_success`, {
        checkout_session_id: cs
      });

      if (response.data.success) {
        console.log('Phone purchase successful:', response.data);
        setChannel(response.data.channel);

        // Refresh channels data to show the new phone number
        await dispatch(fetchChannels());

        // Wait a moment for the user to see the success message
        setTimeout(() => {
          navigate('/channels');
        }, 2000);
      } else {
        console.error('Phone purchase failed:', response.data);
        setError(response.data.message || 'Failed to process phone purchase');
        setTimeout(() => {
          navigate('/channels');
        }, 3000);
      }
    } catch (error) {
      console.error('Error processing phone purchase:', error);
      const errorMessage = error?.response?.data?.message || 'An error occurred while processing your purchase';
      setError(errorMessage);
      enqueueSnackbar(errorMessage, { variant: 'error' });

      setTimeout(() => {
        navigate('/channels');
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <Layout>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', width:'100%' }}>
          <Typography variant="h4" component="h1" gutterBottom color="error">
            Oops! Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, textAlign: 'center', mb: 2 }}>
            {error}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Redirecting to channels page...
          </Typography>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      {/* mui Box which uses flex and centers everything vertically and horizontally */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', width:'100%' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Dialing up your new number...
          </Typography>
          <CircularProgress />
          {/* write a fun fact about dialup */}
        <Typography sx={{ maxWidth: 500, display: 'flex',textAlign:'center', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}} variant="caption" component="h1" gutterBottom>
            {currentQuote}
          </Typography>
      </Box>
      {showConfetti && <ConfettiExplosion />}
    </Layout>
  );
};

export default PhonePurchaseSuccess;
